'use strict';

import $ from 'jquery';

function loadMaps(selector='.google-maps-element') {

  $(selector).each(function(i, mapElem){
    let $mapElem = $(mapElem);
    let mapCanvas = $mapElem.find('.map-canvas').get(0);
    let mapCenter = { lat: 62.7923047, lng: 22.8174933 }; //Seinäjoki

    let mapStyles = [];

    let boundsExist = false;
    let bounds = new window.google.maps.LatLngBounds();

    let markers = $mapElem.data('markers');
    if(markers.length === 1){
      mapCenter.lat = parseFloat(markers[0].latitude);
      mapCenter.lng = parseFloat(markers[0].longitude);
    }
    else if(markers.length > 1){
      boundsExist = true;
    }

    let map = new window.google.maps.Map(mapCanvas, {
      center:  mapCenter,
      zoom: 15,
      fullscreenControl: true,
      mapTypeControl: true,
      panControl: false,
      rotateControl: false,
      scaleControl: false,
      scrollwheel: false,
      streetViewControl: false,
      zoomControl: true,
      styles: mapStyles
    });


    $.each(markers, function(m, marker){
      let latitude = parseFloat(marker.latitude);
      let longitude = parseFloat(marker.longitude);

      if(latitude && longitude){
        let position = { lat: latitude, lng: longitude };

        new window.google.maps.Marker({
          position: position,
          map: map
        });

        if(boundsExist) {
          bounds.extend(position);
        }
      }
    });

    if(boundsExist) {
      // Fit all markers to map
      map.fitBounds(bounds);
    }

  });
}

function getMapScript( callback ) {
  // get goole maps script
  /* apikey by crasman dashboard account, only specific urls allowed */
  let apiKey = 'AIzaSyB5FfntFJ0Ew7w9KzOhuKYREpuY9ruBiJ8';
  let script = '//maps.google.com/maps/api/js?key='+apiKey+'&language=fi&region=FI';
  $.getScript(script, callback);
}

function init() {
  if( $('.generic-map').length > 0 ) {
    $('.generic-map button').on('click',function() {
      getMapScript(() => {
        $('.google-maps-element').removeClass('d-none');
        $('.generic-map').addClass('d-none');
        loadMaps();
      });
    });
  } else if($('.google-maps-element').length > 0) {
    getMapScript(() => {
      loadMaps();
    });
  }
}

export default { init, loadMaps };
export {
  init,
  loadMaps
};
